/**
 * Import Dependency
 */
const { getNeighborhoodPolygon } = require('../../shared/API/neighborhoods')
/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  loaded: false,
  tilesets: [],
  neighborhoodPolygons: {},
}

const getters = {
  tilesets: state => state.tilesets,
  loaded: state => state.loaded,
  GetNeighborhoodPolygon: state => fid => {
    return state.neighborhoodPolygons[fid]
  },
}
const actions = {
  async fetchNeighborhoodPolygon({ commit, state }, { fid }) {
    if (!fid) return null

    if (state.neighborhoodPolygons[fid]) {
      return state.neighborhoodPolygons[fid]
    }

    const token = await this.$auth.getTokenSilently()
    const neighborhood = await getNeighborhoodPolygon(fid, token)

    if (neighborhood) {
      commit('setNeighborhoodPolygon', { fid, neighborhood })
    }

    return neighborhood
  },

}
const mutations = {
  setTilesets(state, { tilesets }) {
    state.tilesets = tilesets
    state.loaded = true
  },
  setNeighborhoodPolygon(state, { fid, neighborhood }) {
    state.neighborhoodPolygons = {
      ...state.neighborhoodPolygons,
      [fid]: neighborhood,
    }
  },
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
